import { type Options } from 'vue3-toastify';

export const successToast = (message: string, options?: Options) => {
  const toast = useNuxtApp().$toast;
  toast.success(message, { ...options, theme: getTheme() });
}

export const errorToast = (message: string, options?: Options) => {
  const toast = useNuxtApp().$toast;

  const defaultOptions: Options = {
    autoClose: 4000,
    ...options,
    theme: getTheme(),
  }

  toast.error(message, defaultOptions);
}

export const infoToast = (message: string, options?: Options) => {
  const toast = useNuxtApp().$toast;
  toast.info(message, { ...options, theme: getTheme() });
}

export const warnToast = (message: string, options?: Options) => {
  const toast = useNuxtApp().$toast;
  toast.warning(message, {
    autoClose: 4000, 
    ...options, 
    theme: getTheme() 
  });
}

export const darkToast = (message: string, options?: Options) => {
  const toast = useNuxtApp().$toast;
  toast.dark(message, { ...options });
}

const getTheme = () => document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';